<template>
  <article>
    <Feature :title="'角色權限維護'" :iconClass="'fa-user-circle-o'">
      <ButtonRow style="justify-content: left">
        <Button type="primary" @click="popAddModal" slot="0">新增</Button>
      </ButtonRow>
      <div class="father">
        <div class="leftChild" id="leftChild">
          <TablePage
            :columnsList="roleColumnsList"
            :resultList="roleList"
            :tableWidth="leftTableWidth"
            @update="clickRow"
            :tableMaxHeight="520"
          ></TablePage>
        </div>
        <div id="line" @mousedown="drag($event)"></div>
        <div class="rightChild" id="rightChild">
          <Tabs v-model="tab" @on-click="clickTabEvent($event)">
            <TabPane label="參數" name="parameter">
              <TablePage
                :columnsList="attributeColumnsList"
                :resultList="checkRole.attributes"
                :tableWidth="rightTableWidth"
                :tableMaxHeight="520"
              ></TablePage>
            </TabPane>
            <TabPane label="功能權限" name="function">
              <Button type="primary" @click="updateFunction()">更新</Button>
              <Scroll height="540">
                <Tree v-if="!req" :data="showfunctionList" show-checkbox :key="componentKey"></Tree>
              </Scroll>
            </TabPane>
            <TabPane label="群組帳號" name="groups">
              <TablePage
                v-if="!req"
                :columnsList="groupsColumnsList"
                :resultList="groupList"
                :tableWidth="rightTableWidth"
                :tableMaxHeight="520"
                :key="componentKey"
              ></TablePage>
            </TabPane>
            <TabPane label="使用者帳號" name="users">
              <TablePage
                v-if="!req"
                :columnsList="userColumnsList"
                :resultList="userList"
                :tableWidth="rightTableWidth"
                :tableMaxHeight="520"
                :key="componentKey"
              ></TablePage>
            </TabPane>
          </Tabs>
        </div>
      </div>
      <Modal
        :width="1100"
        :styles="{ top: '150px' }"
        v-model="upsertRoleModal"
        :title="$t('CREATE_ROLE')"
        @on-ok="confirmUpsertRole"
        :draggable="true"
        sticky
        :z-index="modalSize"
        :reset-drag-position="true"
      >
        <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
          <FormRow :fieldNameArr="['角色代碼', '角色名稱']">
            <Input v-model="upsertRole.code" slot="a" />
            <Input v-model="upsertRole.name" slot="b" />
          </FormRow>
          <TablePage
            :columnsList="createRoleColumnsList"
            :resultList="upsertRole.attributes"
            :tableWidth="rightTableWidth"
            :tableMaxHeight="320"
          >
            <FormRow :fieldNameArr="['參數名稱', '參數值']">
              <Input v-model="attribute.key" slot="a" />
              <Input v-model="attribute.value" slot="b" />
              <Button type="primary" slot="c" @click="addAttribute()" :disabled="!(attribute.key && attribute.value)"
                >Add</Button
              >
            </FormRow>
          </TablePage>
          <div slot="footer">
            <div class="text-center">
              <Button size="large" @click="upsertRoleModal = false">Cancel</Button>
              <Button size="large" type="primary" :disabled="!this.formValid" @click="confirmUpsertRole">Create</Button>
            </div>
          </div>
        </div>
      </Modal>
    </Feature>
  </article>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { create, simple, users, groups, updateFunction, updateRole, removeRole } from "../../util/api/auth/role"
import { Message } from "../../util/common"
import { AlertDelete } from "../../util/alert"
export default {
  name: "AccountMaintain",
  components: {},
  data() {
    const vueInstance = this
    return {
      code: "",
      name: "",
      enabled: "Y",
      roleList: [],
      checkRole: {},
      funcitonList: [],
      userList: [],
      groupList: [],
      leftTableWidth: "1300",
      rightTableWidth: "1300",
      roleColumnsList: [
        {
          title: "角色代碼",
          key: "code",
        },
        {
          title: "角色名稱",
          key: "name",
        },
        {
          title: "角色狀態",
          key: "enabled",
          maxWidth: 120,
        },
        {
          title: "操作",
          maxWidth: 120,
          render: (h, params) => {
            return (
              <div class="cell-button-container">
                <Button
                  type="info"
                  shape="circle"
                  class="mr-2"
                  onClick={() => {
                    vueInstance.attribute = {
                      key: "",
                      value: "",
                    }
                    vueInstance.upsertRole = params.row
                    vueInstance.createModal = false
                    vueInstance.upsertRoleModal = true
                  }}
                  icon="ios-open-outline"></Button>
                <Button
                  type="error"
                  shape="circle"
                  onClick={() => {
                    this.deleteRole(params.row.id)
                  }}
                  icon="ios-trash"></Button>
              </div>
            )
          },
        },
      ],
      userColumnsList: [
      {
          title: "角色代碼",
          key: "code",
        },
        {
          title: "使用者帳號",
          key: "username",
        },
        {
          title: "Email",
          key: "email",
          width: 300,
        },
        {
          title: "角色狀態",
          key: "enabled",
          maxWidth: 120,
        },
        {
          title: "操作",
          maxWidth: 120,
          render: (h, params) => {
            return (
              <div class="cell-button-container">
                <Button
                  type="error"
                  shape="circle"
                  onClick={() => {
                    this.deleteUser(params.row)
                  }}
                  icon="ios-trash"></Button>
              </div>
            )
          },
        },
      ],
      groupsColumnsList: [
        {
          title: "群組代碼",
          key: "code",
        },
        {
          title: "群組狀態",
          key: "enabled",
          maxWidth: 120,
        },
      ],
      attributeColumnsList: [
        {
          title: "參數名稱",
          key: "key",
        },
        {
          title: "參數值",
          key: "value",
        },
      ],
      createRoleColumnsList: [
        {
          title: "參數名稱",
          key: "key",
        },
        {
          title: "參數值",
          key: "value",
        },
        {
          title: "操作",
          render: (h, params) => {
            return (
              <div class="cell-button-container">
                <Button
                  type="error"
                  shape="circle"
                  onClick={() => {
                    this.deleteCreateRole(params.index)
                  }}
                  icon="ios-trash"></Button>
              </div>
            )
          },
        },
      ],
      showfunctionList: [],
      upsertRoleModal: false,
      upsertRole: {
        attributes: [],
        code: "",
        description: "",
        enabled: true,
        name: "",
      },
      attribute: {
        key: "",
        value: "",
      },
      tab: "parameter",
      componentKey: 0,
      req: false,
      createModal: true,
    }
  },
  created() {
    this.searchData()
  },
  methods: {
    ...mapGetters(["getModalSize"]),
    ...mapActions(["toggleLoading"]),
    popAddModal() {
      const vueInstance = this
      vueInstance.upsertRole = {
        attributes: [],
        code: "",
        description: "",
        enabled: true,
        name: "",
      }
      vueInstance.attribute = {
        key: "",
        value: "",
      }
      vueInstance.createModal = true
      vueInstance.upsertRoleModal = true
    },
    addAttribute() {
      const vueInstance = this
      const keyDuplicate = vueInstance.upsertRole.attributes.some(item => {
        if (item.key === vueInstance.attribute.key) {
          return true
        }
      })
      if (keyDuplicate) {
        Message(vueInstance, "error", "參數名稱不能重複")
      } else {
        vueInstance.upsertRole.attributes.push(vueInstance.attribute)
        vueInstance.attribute = {
          key: "",
          value: "",
        }
      }
    },
    deleteCreateRole(index) {
      const vueInstance = this
      vueInstance.upsertRole.attributes.splice(index, 1)
    },
    deleteRole(id) {
      const vueInstance = this

      AlertDelete(vueInstance, `是否確認要停用這筆項目?`)
        .then(() => {
          vueInstance.toggleLoading(true)
          removeRole(vueInstance, id).then(res => {
            if (res.status === 200) {
              vueInstance.toggleLoading(false)
              vueInstance.searchData()
            }
          })
        })
        .catch(() => {})
    },
    clickRow(row) {
      const vueInstance = this
      vueInstance.checkRole = row.item
      vueInstance.getRightTabData()
    },
    drag(ev) {
      var leftChild = document.getElementById("leftChild")
      var rightChild = document.getElementById("rightChild")
      var iEvent = ev || event
      var dx = iEvent.clientX
      var leftWidth = leftChild.offsetWidth
      var rightWidth = rightChild.offsetWidth
      document.onmousemove = function(ev) {
        var iEvent = ev || event
        var diff = iEvent.clientX - dx
        if (200 < leftWidth + diff && 200 < rightWidth - diff) {
          leftChild.style.width = leftWidth + diff + "px"
          this.leftTableWidth = leftWidth + diff
          rightChild.style.width = rightWidth - diff + "px"
          this.rightTableWidth = rightWidth - diff
        }
      }
      document.onmouseup = function() {
        document.onmousedown = null
        document.onmousemove = null
      }
    },
    searchData() {
      const vueInstance = this
      vueInstance.roleList = []
      vueInstance.toggleLoading(true)
      simple(vueInstance, "").then(response => {
        if (response.data._embedded != undefined) {
          vueInstance.roleList = response.data._embedded.roleResourceList
          vueInstance.checkRole = vueInstance.roleList[0]
          vueInstance.getRightTabData()
        }
      })
    },
    buildFunctionList() {
      const vueInstance = this
      vueInstance.showfunctionList = []
      vueInstance.funcitonList.forEach(parent => {
        let children1 = []
        vueInstance.showfunctionList.push({
          title: parent.data.name,
          uuid: parent.data.uuid,
          code: parent.data.code,
          checked: parent.checked,
          expand: true,
          children: children1,
        })

        if (parent.children) {
          parent.children.forEach(childrenOne => {
            let cheildren2 = []
            children1.push({
              title: childrenOne.data.name,
              uuid: childrenOne.data.uuid,
              code: childrenOne.data.code,
              checked: childrenOne.checked,
              expand: true,
              children: cheildren2,
            })

            if (childrenOne.children) {
              childrenOne.children.forEach(childrentwo => {
                cheildren2.push({
                  title: childrentwo.data.name,
                  uuid: childrentwo.data.uuid,
                  code: childrentwo.data.code,
                  checked: childrentwo.checked,
                })
              })
            }
          })
        }
      })
    },
    updateFunction() {
      const vueInstance = this
      let updateFunctionList = []
      vueInstance.showfunctionList.forEach(funs => {
        if (funs.checked) {
          updateFunctionList.push({
            code: funs.code,
            uuid: funs.uuid,
          })
        } 
        funs.children.forEach(oneChildFuns => {
          if (oneChildFuns.checked) {
            updateFunctionList.push({
              code: oneChildFuns.code,
              uuid: oneChildFuns.uuid,
            })
          } 
          oneChildFuns.children.forEach(twoChildFuns => {
            if (twoChildFuns.checked) {
              updateFunctionList.push({
                code: twoChildFuns.code,
                uuid: twoChildFuns.uuid,
              })
            }
          })
        })
      })

      vueInstance.toggleLoading(true)
      updateFunction(vueInstance, vueInstance.checkRole.id, {
        functions: updateFunctionList,
      }).then(() => {
        Message(vueInstance, "success", vueInstance.$t("COMMON_MESSAGE_SUCCESSFULLY"))
        vueInstance.toggleLoading(false)
        vueInstance.getRightTabData()
      })
    },
    confirmUpsertRole() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.upsertRole.description = vueInstance.upsertRole.code
      vueInstance.upsertRole.roleI18nMap = {}
      if (vueInstance.createModal) {
        create(vueInstance, vueInstance.upsertRole).then(res => {
          if (res.status === 200) {
            vueInstance.toggleLoading(false)
            vueInstance.upsertRoleModal = false
            vueInstance.searchData()
          }
        })
      } else {
        updateRole(vueInstance, vueInstance.upsertRole.id, vueInstance.upsertRole).then(res => {
          if (res.status === 200) {
            vueInstance.toggleLoading(false)
            vueInstance.upsertRoleModal = false
            vueInstance.searchData()
          }
        })
      }
    },
    getRightTabData() {
      const vueInstance = this
      console.log(vueInstance.tab)
      if (vueInstance.tab === "users") {
        ++vueInstance.componentKey
        vueInstance.toggleLoading(true)
        vueInstance.req = true
        users(vueInstance, vueInstance.checkRole.id)
          .then(res => {
            if (res.status === 200) {
              vueInstance.userList = res.data?._embedded?.userResourceList ?? []
            }
            console.log(vueInstance.userList)
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
            vueInstance.req = false
          })
      } else if (vueInstance.tab === "function") {
        ++vueInstance.componentKey
        vueInstance.funcitonList = []
        vueInstance.showfunctionList = []
        vueInstance.toggleLoading(true)
        vueInstance.req = true
        vueInstance.$authHttp
          .get("function/search/ROLE_BINDING?role-code=" + vueInstance.checkRole.code)
          .then(response => {
            if (response.data._embedded != undefined) {
              vueInstance.funcitonList = response.data._embedded.nodeDtoList
            }
            vueInstance.buildFunctionList()
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
            vueInstance.req = false
          })
      } else if (vueInstance.tab === "groups") {
        vueInstance.toggleLoading(true)
        vueInstance.groupList = []
        vueInstance.req = true
        groups(vueInstance, vueInstance.checkRole.id)
          .then(res => {
            if (res.status === 200) {
              vueInstance.groupList = res.data?._embedded?.groupResourceList ?? []
            }
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
            vueInstance.req = false
          })
      } else {
        vueInstance.toggleLoading(false)
      }
    },
    clickTabEvent(tab) {
      const vueInstance = this
      vueInstance.tab = tab
      vueInstance.getRightTabData()
    },
  },
  computed: {
    formValid() {
      const vueInstance = this
      return vueInstance.upsertRole.code && vueInstance.upsertRole.name && vueInstance.upsertRole.attributes.length > 0
    },
    modalSize() {
      return this.getModalSize()
    }
  },
}
</script>

<style scoped>
.father {
  box-sizing: border-box;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.leftChild {
  float: left;
  height: 100%;
  width: 50%;
  border: solid #5f9ea0;
  resize: horizontal;
  box-sizing: border-box;
}
.rightChild {
  float: left;
  height: 100%;
  width: calc(50% - 5px);
  border: solid #5f9ea0;
  box-sizing: border-box;
}
#line {
  width: 2px;
  height: 100%;
  background-color: white;
  float: left;
  cursor: e-resize;
}
.cell-button-containe {
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
}
</style>
